// extracted by mini-css-extract-plugin
export default {"containerOperationCostRegister":"CostOperations_containerOperationCostRegister__cwlj7","btn":"CostOperations_btn__7ipg9","totals":"CostOperations_totals__twWXy"};